import { render, staticRenderFns } from "./UnitCost.vue?vue&type=template&id=138ea18a&scoped=true"
import script from "./UnitCost.vue?vue&type=script&lang=ts"
export * from "./UnitCost.vue?vue&type=script&lang=ts"
import style0 from "./UnitCost.vue?vue&type=style&index=0&id=138ea18a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138ea18a",
  null
  
)

export default component.exports